module.exports = __webpack_public_path__ + "static/media/s_v9_t6.2735ed34.mp3";